"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterBranchMarkerCommand = exports.AdvancedBranchMarkerCommand = exports.NormalBranchMarkerCommand = exports.BranchMarkerCommand = void 0;
const Command_1 = require("../Command");
const BranchType_1 = require("../lib/BranchType");
const CommandType_1 = require("../lib/CommandType");
/**
 * Marks the beginning of a branch in a chart with diverge notes.
 *
 * **Example:**
 *
 * ```
 * 5800,
 * 0,
 * #BRANCHSTART r,1,2
 * #N
 * 1111,
 * #E
 * 22202220,
 * #M
 * 12121212,
 * ```
 */
class BranchMarkerCommand extends Command_1.Command {
    constructor(branchType) {
        super(CommandType_1.CommandType.BranchMarker);
        this.branchType = branchType;
    }
    static parse(branchType) {
        switch (branchType) {
            case BranchType_1.BranchType.Normal:
                return new NormalBranchMarkerCommand();
            case BranchType_1.BranchType.Advanced:
                return new AdvancedBranchMarkerCommand();
            case BranchType_1.BranchType.Master:
                return new MasterBranchMarkerCommand();
        }
    }
    toString() {
        return `#${this.branchType.toString()}`;
    }
}
exports.BranchMarkerCommand = BranchMarkerCommand;
/**
 * Marks the beginning of the Normal branch.
 */
class NormalBranchMarkerCommand extends BranchMarkerCommand {
    constructor() {
        super(BranchType_1.BranchType.Normal);
    }
}
exports.NormalBranchMarkerCommand = NormalBranchMarkerCommand;
/**
 * Marks the beginning of the Advanced or Professional branch.
 */
class AdvancedBranchMarkerCommand extends BranchMarkerCommand {
    constructor() {
        super(BranchType_1.BranchType.Advanced);
    }
}
exports.AdvancedBranchMarkerCommand = AdvancedBranchMarkerCommand;
/**
 * Marks the beginning of the Master branch.
 */
class MasterBranchMarkerCommand extends BranchMarkerCommand {
    constructor() {
        super(BranchType_1.BranchType.Master);
    }
}
exports.MasterBranchMarkerCommand = MasterBranchMarkerCommand;
